import React from "react";
import styled from "styled-components";
// import Button from "../Button.js";
import { Link } from "react-router-dom";

const FormContainer = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  max-width: 420px;
  margin: 2rem auto;
  padding: 2.5rem 2rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2`
  color: #2d3748;
  margin-bottom: 2rem;
`;

const StyledForm = styled.form`
  width: 100%;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.3rem;
  color: #4a5568;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.6rem 0.9rem;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  margin-bottom: 1.2rem;
  font-size: 1rem;
  background: #f7fafc;
  transition: border-color 0.2s;
  &:focus {
    border-color: #3182ce;
    outline: none;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  background: linear-gradient(90deg, #667eea 0%, #5a67d8 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.85rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.5rem;
  &:hover {
    background: linear-gradient(90deg, #5a67d8 0%, #667eea 100%);
  }
`;

const ResponseMsg = styled.div`
  margin-top: 1.5rem;
  color: #38a169;
  font-weight: 500;
  min-height: 24px;
`;

class FormAddCourse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      item: "",
      data: "",
      image: null,
      response: "",
      tense: "",
      aspect: "",
      modifier: "",
      generatedId: "",
    };
  }

  handleTitleInput = (e) => {
    this.setState({ title: e.target.value, response: "" });
  };

  handleTenseChange = (e) => {
    this.setState({ tense: e.target.value }, this.generateId);
  };

  handleAspectChange = (e) => {
    this.setState({ aspect: e.target.value }, this.generateId);
  };

  handleModifierChange = (e) => {
    this.setState({ modifier: e.target.value }, this.generateId);
  };

  generateId = () => {
    const { tense, aspect, modifier } = this.state;
    let id = "";
    if (modifier) id += modifier.toUpperCase() + ".";
    if (tense) id += tense.toUpperCase() + ".";
    if (aspect) id += aspect.toUpperCase();
    id = id.replace(/\.$/, "");
    this.setState({ generatedId: id });
  };
  handleItemInput = (e) => {
    this.setState({ item: e.target.value, response: "" });
  };
  handleDataInput = (e) => {
    this.setState({ data: e.target.value, response: "" });
  };
  handleImageInput = (e) => {
    this.setState({ image: e.target.files[0], response: "" });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    fetch(process.env.REACT_APP_API_URL + "/course", {
      method: "POST",
      body: JSON.stringify({
        course_id: this.state.generatedId,
        course_title: this.state.title,
        course_item: this.state.item,
        course_image: this.state.image,
        course_data: this.state.data,
        tense: this.state.tense,
        aspect: this.state.aspect,
        modifier: this.state.modifier,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: localStorage.getItem("jstoken"),
      },
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          response: "Last course added: " + this.state.item,
          title: "",
          data: "",
          item: "",
          image: null,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    return (
      <FormContainer>
        <Title>Add a Course</Title>
        <StyledForm onSubmit={this.handleSubmit}>
          <Label>Tense</Label>
          <select
            value={this.state.tense}
            onChange={this.handleTenseChange}
            required
            style={{
              width: "100%",
              padding: "0.6rem 0.9rem",
              marginBottom: "1.2rem",
              border: "1px solid #cbd5e0",
              borderRadius: "6px",
              background: "#f7fafc",
            }}
          >
            <option value="">Select Tense</option>
            <option value="PRES">Present</option>
            <option value="PAST">Past</option>
            <option value="FUT">Future</option>
          </select>
          <Label>Aspect</Label>
          <select
            value={this.state.aspect}
            onChange={this.handleAspectChange}
            required
            style={{
              width: "100%",
              padding: "0.6rem 0.9rem",
              marginBottom: "1.2rem",
              border: "1px solid #cbd5e0",
              borderRadius: "6px",
              background: "#f7fafc",
            }}
          >
            <option value="">Select Aspect</option>
            <option value="SIMP">Simple</option>
            <option value="CONT">Continuous</option>
            <option value="PERF">Perfect</option>
            <option value="PERFCONT">Perfect Continuous</option>
          </select>
          <Label>Modifier</Label>
          <select
            value={this.state.modifier}
            onChange={this.handleModifierChange}
            style={{
              width: "100%",
              padding: "0.6rem 0.9rem",
              marginBottom: "1.2rem",
              border: "1px solid #cbd5e0",
              borderRadius: "6px",
              background: "#f7fafc",
            }}
          >
            <option value="">None</option>
            <option value="M">Modal</option>
            <option value="PASV">Passive</option>
          </select>
          <Label>Generated Course ID</Label>
          <Input
            type="text"
            value={this.state.generatedId}
            readOnly
            placeholder="Auto-generated ID"
            style={{ background: "#e2e8f0", fontWeight: 600 }}
          />

          <Label>Title</Label>
          <Input
            type="text"
            value={this.state.title}
            onChange={this.handleTitleInput}
            placeholder="Course Title"
            required
          />
          <Label>Item</Label>
          <Input
            type="text"
            value={this.state.item}
            onChange={this.handleItemInput}
            placeholder="Course Item"
            required
          />
          <Label>Data</Label>
          <Input
            type="text"
            value={this.state.data}
            onChange={this.handleDataInput}
            placeholder="Course Data"
            required
          />
          <Label>Image</Label>
          <Input
            type="file"
            accept="image/png, image/jpeg, image/gif"
            onChange={this.handleImageInput}
          />
          <SubmitButton type="submit">Add Course</SubmitButton>
        </StyledForm>
        <ResponseMsg>{this.state.response}</ResponseMsg>
      </FormContainer>
    );
  }
}

export default FormAddCourse;
